import { LoggingModule } from "@pns-fe/sdk-common-modules";
import { CONSENT_DATA_STORAGE_NAME } from "../../constants/env";
import { StorageType } from "../../constants/sdk";
import InMemStorageWrapper from "./storage/InMemStorageWrapper";
import { LocalStorageWrapper, SessionStorageWrapper } from "./storage/WebStorageWrapper";
const StorageClassMap = {
  [StorageType.inMem]: InMemStorageWrapper,
  [StorageType.localStorage]: LocalStorageWrapper,
  [StorageType.sessionStorage]: SessionStorageWrapper
};
class StorageModule {
  constructor() {
    if (!StorageModule._instance) {
      StorageModule._instance = this;
    }
    return StorageModule._instance;
  }
  init(config) {
    LoggingModule.info("[StorageModule]: init");
    const { storageType = StorageType.sessionStorage } = config != null ? config : {};
    if (storageType) {
      if (!Object.values(StorageType).includes(storageType)) {
        LoggingModule.error(`[StorageModule]: init - Invalid Storage Type ${storageType}`, {
          storageType
        });
      }
      this._setupStorage(storageType);
    }
  }
  getRecord(key, userInfo) {
    LoggingModule.info("[StorageModule]: getRecord", { key });
    return this._store.getRecord(key, userInfo);
  }
  getRecords(keys, userInfo) {
    LoggingModule.info("[StorageModule]: getRecords", { keys });
    return this._store.getRecords(keys, userInfo);
  }
  getEntity(key, userInfo) {
    LoggingModule.info("[StorageModule]: getEntity", { key });
    return this._store.getEntity(key, userInfo);
  }
  getEntities(keys, userInfo) {
    LoggingModule.info("[StorageModule]: getEntities", { keys });
    return this._store.getEntities(keys, userInfo);
  }
  getCollectionPoint(collectionPointId, userInfo) {
    LoggingModule.info("[StorageModule]: getCollectionPoint", { collectionPointId });
    return this._store.getCollectionPoint(collectionPointId, userInfo);
  }
  insertConsentData(data, timestamp, userInfo) {
    LoggingModule.info("[StorageModule]: insertConsentData", { data, timestamp });
    try {
      this._inMemStore.insertConsentData(data, timestamp, userInfo);
      this._store.insertConsentData(data, timestamp, userInfo);
    } catch (error) {
      if (error instanceof DOMException && error.name === "QuotaExceededError") {
        LoggingModule.error(
          "[StorageModule]: insertConsentData - Storage limit exceeded, switch to in mem storage",
          error
        );
      } else {
        LoggingModule.error("[StorageModule]: insertConsentData - Error", error);
      }
      this._store.destruct();
      this._store = this._inMemStore;
    }
  }
  getNotificationData(userInfo) {
    LoggingModule.info("[StorageModule]: getNotificationData", { userInfo });
    return this._store.getNotificationData(userInfo);
  }
  insertNotificationData(data, timestamp, userInfo) {
    LoggingModule.info("[StorageModule]: insertNotificationData", { data, timestamp });
    try {
      this._inMemStore.insertNotificationData(data, timestamp, userInfo);
      this._store.insertNotificationData(data, timestamp, userInfo);
    } catch (error) {
      if (error instanceof DOMException && error.name === "QuotaExceededError") {
        LoggingModule.error(
          "[StorageModule]: insertNotificationData - Storage limit exceeded, switch to in mem storage",
          error
        );
      } else {
        LoggingModule.error("[StorageModule]: insertNotificationData - Error", error);
      }
      this._store.destruct();
      this._store = this._inMemStore;
    }
  }
  _checkStorage(storageType) {
    LoggingModule.info("[StorageModule]: checkStorage", { storageType });
    if (storageType === StorageType.inMem) {
      return true;
    }
    try {
      const current = window[storageType].getItem(CONSENT_DATA_STORAGE_NAME);
      if (!current) {
        window[storageType].setItem(CONSENT_DATA_STORAGE_NAME, "{}");
        window[storageType].removeItem(CONSENT_DATA_STORAGE_NAME);
        return true;
      } else {
        window[storageType].setItem(CONSENT_DATA_STORAGE_NAME, current);
        return true;
      }
    } catch (error) {
      return false;
    }
  }
  _setupStorage(storageType) {
    LoggingModule.info("[StorageModule]: setupStorage", { storageType });
    this._inMemStore = new InMemStorageWrapper();
    if (storageType && this._checkStorage(storageType)) {
      const StorageClass = StorageClassMap[storageType];
      this._store = new StorageClass();
    } else if (this._checkStorage(StorageType.sessionStorage)) {
      this._store = new SessionStorageWrapper();
    } else if (this._checkStorage(StorageType.localStorage)) {
      this._store = new LocalStorageWrapper();
    } else {
      this._store = this._inMemStore;
    }
  }
  clean() {
    LoggingModule.info("[StorageModule]: clean");
    if (this._store) {
      this._store.clean();
    }
    if (this._inMemStore) {
      this._inMemStore.clean();
    }
  }
  destruct() {
    LoggingModule.info("[StorageModule]: destruct");
    this.clean();
  }
}
var StorageModule_default = new StorageModule();
export {
  StorageModule_default as default
};
